import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Consent = function Consent(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c5.238 0 9.5 3.622 9.5 8.075 0 4.453-4.262 8.075-9.5 8.075-1.37 0-2.691-.243-3.93-.721a.782.782 0 0 0-.661.053L4.76 20.95a.402.402 0 0 1-.436-.028.43.43 0 0 1-.167-.416l.463-2.858a.858.858 0 0 0-.205-.71C3.163 15.528 2.5 13.847 2.5 12.075 2.5 7.622 6.762 4 12 4zm4.301 6.126a.867.867 0 0 0 0-1.202.81.81 0 0 0-1.168 0l-4.372 4.499-1.894-1.95a.81.81 0 0 0-1.169 0 .867.867 0 0 0 0 1.203l2.479 2.55a.81.81 0 0 0 1.168 0l4.956-5.1z"
  })));
};

Consent.displayName = 'Consent';
export default Consent;